import { UiFee, UiRate } from '@razz-team/ui-web';
import { ApiFees, ApiQuote } from '../../openapi';
import { useMemo } from 'react';

// well, it's better to use tagged types here, but it's fine for now
const RENDER_LOADER = null;
const DO_NOT_RENDER = undefined;

type UiFalsy = typeof RENDER_LOADER | typeof DO_NOT_RENDER;

export function useUiFees(fees: ApiFees | undefined | null): UiFee[] | UiFalsy {
  const uiFees = useMemo(() => {
    return fees
      ? Object.entries(fees).reduce((acc, [type, fee]) => {
          if (fee?.sourceAmount) {
            acc.push({
              type,
              value: fee.sourceAmount,
            });
          }
          return acc;
        }, [] as UiFee[])
      : RENDER_LOADER;
  }, [fees]);

  return uiFees;
}

export function useUiRate(quote: ApiQuote | undefined | null): UiRate | UiFalsy {
  const uiRate = useMemo(() => {
    if (quote) {
      if (quote.fx) {
        return {
          price: quote.fx.rate.ask,
          currencyPair: quote.fx.rate.currencyPair,
        };
      }

      return DO_NOT_RENDER;
    }

    return RENDER_LOADER;
  }, [quote]);

  return uiRate;
}
